import React, { useEffect, useState } from "react";
import { useSetState, useUpdateEffect } from "ahooks";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import api from "../../api/index";

import UseSwiper from "../../component/UseSwiper";
import UseGoodsSwiper from "../../component/UseGoodsSwiper";
import UseGoodsMain from "../../component/UseGoodsMain";
import UseMask from "../../component/UseMask";

import { getUrlParams } from "../../tools/index";

import "./style.scss";
const UseGoods: React.FC = () => {
  const urlState = useLocation();
  const navigate = useNavigate();
  // 苏州到授权
  useEffect(() => {
    // localStorage.setItem("szd_token", "BaeCCsZLEVILTvKbwXDj");
    // return;
    if (urlState.key === "default") {
      let type = getUrlParams(urlState.search, "auth_ok");
      console.log("type =>", type);
      if (type === "2") {
        return;
      }
      if (type === "") {
        console.log("获取授权配置 =>");
        // 获取授权配置
        get_auth_config();
      } else {
        if (type === "1") {
          console.log("拿到授权配了，获取token =>");
          // type 为1 才获取token
          get_token();
        }
      }
    } else {
      console.log("重定向");
    }
  }, []);

  const get_auth_config = () => {
    axios.get(GLOBAL_API_URL + "/login/config").then((resp: any) => {
      let res = resp.data;
      if (res.code === 1) {
        (window as any).gotoOauth(
          res.data.appid,
          res.data.scope,
          "蓝色兄弟",
          "https://suzhoudao.oss-cn-hangzhou.aliyuncs.com/lanse-logo.png",
          `${GLOBAL_H5_BACK}${urlState.search}&state=${res.data.state}&auth_ok=1`
        );
      } else {
        popBox(res.msg);
      }
    });
  };

  const get_token = () => {
    let get_token_url = `${GLOBAL_API_URL}/login/token${urlState.search}`;
    axios.get(get_token_url).then((resp: any) => {
      let res = resp.data;
      if (res.code === 1) {
        localStorage.setItem("szd_token", res.data.login_token);
        localStorage.setItem("account", res.data.mobile); /* 回调手机号 */
        setState({ account: res.data.mobile });
        console.log("获取到token 重定向 => auth_ok 2");
        navigate(`/?${urlState.search}&auth_ok=2`);
      } else {
        popBox(res.msg);
      }
    });
  };

  const [state, setState] = useSetState<any>({
    bannerList: [],
    goodsList: [],
    goodsTypeID: getUrlParams(urlState.search, "goods_type_id"),
    goodsID: getUrlParams(urlState.search, "goods_id"),
    goodsSpecID: getUrlParams(urlState.search, "product_id"),
    specID: "",
    checkedGoodsData: null,
    checkedGoodsTitle: [],
    productList: [],
    checkedProductData: {
      product: []
    },
    account: localStorage.getItem("account") || "",
    isOpenDialog: false,
    maskMsg: "",
    goods_type_name: "充值中心"
  });

  // 改变title
  useEffect(() => {
    document.title = state.checkedGoodsData?.goods_type_name || "充值中心";
  }, [state.checkedGoodsData]);

  useEffect(() => {
    getBannerList();
    getGoodsList();
  }, []);

  // 获取banner list
  const getBannerList = () => {
    let params = {
      goods_type_id: state.goodsTypeID
    };
    api.goods.getBannerList<Types.Http.IBannerRes[]>(params).then((res) => {
      setState({
        bannerList: res.data
      });
    });
  };

  // 获取商品列表
  const getGoodsList = () => {
    let params = {
      goods_type_id: state.goodsTypeID
    };
    api.goods.getGoodsList<Types.Http.IGoodsRes[]>(params).then((resp) => {
      if (resp.data.length > 0) {
        // 如果是 goodsID 不存在
        if (state.goodsID === "") {
          setState({
            goodsList: resp.data,
            goodsID: resp.data[0].goods_id,
            checkedGoodsData: resp.data[0]
          });
        } else {
          setState({
            goodsList: resp.data,
            checkedGoodsData: resp.data.find(
              (item) => item.goods_id === Number(state.goodsID)
            )
          });
        }
        getProductDetail(resp.data);
      }
    });
  };

  // 获取商品详情
  const getProductDetail = (goodsList: any) => {
    let params = {
      goods_id: state.goodsID === "" ? goodsList[0].goods_id : state.goodsID,
      goods_spec_id: state.goodsSpecID
    };
    api.goods
      .getGoodsDetail<Types.Http.IGoodsDetailRes[]>(params)
      .then((resp) => {
        console.log("获取商品详情 =>", resp);
        setState({
          productList: resp.data
        });

        // 获取
        for (let i = 0; i < resp.data.length; i++) {
          if (resp.data[i].is_selected) {
            setState({
              specID: resp.data[i].spec_id,
              checkedProductData: resp.data[i]
            });
            return;
          }
        }
        setState({
          goodsSpecID: resp.data[0].product[0].goods_spec_id,
          specID: resp.data[0].spec_id,
          checkedProductData: resp.data[0]
        });
      });
  };

  // 设置选中商品
  const setGoodsID = (goodsID: string) => {
    let el = state.goodsList.find(
      (item: any) => item.goods_id === Number(goodsID)
    );
    if (el) {
      setState({
        checkedGoodsData: el,
        goodsID: goodsID
      });

      let params = {
        goods_id: goodsID
      };
      api.goods
        .getGoodsDetail<Types.Http.IGoodsDetailRes[]>(params)
        .then((resp) => {
          setState({
            productList: resp.data,
            checkedProductData: resp.data[0],
            specID: resp.data[0].spec_id,
            goodsSpecID: resp.data[0].product[0].goods_spec_id
          });
        });
    }
  };

  // 设置规格选中
  const setSpecID = (specID: string) => {
    // 皮肤
    let el = state.productList.find((item: any) => item.spec_id === specID);
    // console.log(el);
    if (el) {
      setState({
        specID: specID,
        checkedProductData: el,
        goodsSpecID: el.product[0].goods_spec_id
      });
    }
  };

  // 设置规格商品选中
  const setGoodsSpecID = (data: number) => {
    setState({
      goodsSpecID: data
    });
  };

  // 输入账号
  const setAccount = (account: string) => {
    // console.log("account =>", account);
    setState({
      account: account
    });
  };

  const popBox = (msg: string) => {
    setState({ maskMsg: msg, isOpenDialog: true });
    setTimeout(() => {
      setState({
        isOpenDialog: false
      });
    }, 500);
  };

  // 付款
  const payMoney = () => {
    if (state.account === "") {
      popBox("请输入账号");
      return;
    }
    let params = {
      account: state.account,
      goods_spec_id: Number(state.goodsSpecID)
    };
    // console.log("params =>", params);
    api.pay.payMoney(params).then((resp) => {
      if (resp.code === 1) {
        localStorage.setItem("pre_pay_url", resp.data.pre_pay_url);
        localStorage.setItem("url_search", urlState.search);
        setTimeout(() => {
          navigate(`/payResult?time=${new Date().getTime()}`);
        }, 100);
        // (window as any).openWebPage(resp.data.pre_pay_url);
      } else if (resp.code === -1) {
        // szd_Auth_init();
      } else {
        popBox(resp.msg);
      }
      // console.log("pay =>", resp);
    });
  };

  return (
    <div className="goods">
      <UseSwiper bannerList={state.bannerList}></UseSwiper>

      {state.goodsID ? (
        <UseGoodsSwiper
          goodsList={state.goodsList}
          goodsID={state.goodsID}
          setGoodsID={setGoodsID}
        ></UseGoodsSwiper>
      ) : (
        <span className="on_data">暂无数据</span>
      )}

      {state.checkedGoodsData ? (
        <UseGoodsMain
          checkedGoodsData={state.checkedGoodsData}
          productList={state.productList}
          specID={state.specID}
          setSpecID={setSpecID}
          goodsSpecID={state.goodsSpecID}
          setGoodsSpecID={setGoodsSpecID}
          checkedProductData={state.checkedProductData}
          setAccount={setAccount}
          account={state.account}
          payMoney={payMoney}
        ></UseGoodsMain>
      ) : null}

      {state.isOpenDialog ? <UseMask msg={state.maskMsg}></UseMask> : null}
    </div>
  );
};
export default UseGoods;
